// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e72cb59b","148":"620cf98c","259":"1d9719d8","612":"b07b03fc","614":"7618509c","630":"47878720","671":"396a01c9","700":"7ec0ca0b","749":"313d2cd5","787":"66adc0c1","873":"e6bad9a8"}[chunkId] + ".chunk.js";
};